"use client"

import type { TrackEventProperties } from "@/modules/tracking/types"
import type { FunctionComponent } from "react"

import { useEffect } from "react"

import { useTracking } from "@/modules/tracking/useTracking"

type TrackRenderProps = {
  trackingProps: TrackEventProperties
}

export const TrackRender: FunctionComponent<TrackRenderProps> = ({ trackingProps: { eventName, eventProperties } }) => {
  const tracking = useTracking()

  useEffect(() => {
    tracking?.track(eventName, eventProperties)
  }, [tracking, eventName, eventProperties])

  return null
}
